import { useEffect, useState } from 'react';

export const useIsVisible = (ref: { current: Element }, dependencies: any = []) => {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting));

    ref.current && observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [ref, ...dependencies]);

  return isIntersecting;
};
